import { useEffect, useState, forwardRef } from "react";
import { vocabularize } from "src/Common/vocab";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { isAccountant, isAdmin, isClericalOver, isProjectManagerOver } from "src/Common/function";
import CustomerDropDown from "./dropdown/customerdropdown";
import QuotedByDropdown from "./dropdown/QuotedByDropdown";
import CustomerService from "src/Services/API/customer.service";
import ServiceTypeDropdown from "./dropdown/ServiceTypeDropdown";
import { WO_TYPE_LIST } from "src/Common/contants";
import UserService from "src/Services/API/user.service";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import WOStatusDropDown from "./dropdown/wostatusdropdown";
import DatePickerModal from "src/Common/datepickermodal";
import { formatDate, toLocalDate } from "src/Common/common";
import DateInput from "src/Components/Input/dateinput";
import Loader from "src/Components/Common/Loader";
import UserDropDown from "./AssignTech/userdropdown";
import { can, handleError } from "src/Common/function";
import ServiceTypeAddModal from "src/Pages/Setting/services/ServiceTypeAddModal";
import ServiceTypeService from "src/Services/API/service.service";

function CreateWoModal({ order, shown, onCancelClicked, onSubmitClicked }) {
  const currentUser = UserService.getCurrentUser();
  const [woNumber, setWoNumber] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [customerNames, setCustomerNames] = useState([]);
  const [quotedByUsers, setQuotedByUsers] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [customerName, setCustomerName] = useState("");
  const [serviceType, setServiceType] = useState(null);
  const [quotedByUser, setQuotedByUser] = useState(null);
  const [nte, setNte] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [asset, setAsset] = useState("");
  const [customerPONumber, setCustomerPONumber] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(-1);
  //primary technician
  const [primaryTech, setPrimaryTech] = useState(null);
  const [technicians, setTechnicians] = useState([]);
  const [isUserDropDownOpen, setIsUserDropDownOpen] = useState(false);

  const [showAddServiceTypeModal, setShowAddServiceTypeModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const StartInput = forwardRef(({ value, onClick }, ref) => <DateInput text={value} onClick={onClick} />);

  const [customerKeyword, setCustomerKeyword] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const criteria = searchParams.get("criteria");
  const branch = Number(searchParams.get("branch"));

  useEffect(() => {
    getQuotedByUsers();
    getCustomers();
  }, [shown, customerKeyword]);

  const getQuotedByUsers = async () => {
    try {
      // Roles are dynamic (managed in IAM), so the picker lists all enabled
      // users instead of hardcoding role names.
      const response = await UserService.getUsersForAssign(null);
      setQuotedByUsers(
        response.data.filter((user) => user.isEnabled === true).sort((a, b) => a.name.localeCompare(b.name)),
      );
    } catch (error) {
      console.log("quoted by users fetching error: ", error);
    }
  };

  useEffect(() => {
    setIsSubmitting(false);
    if (order) {
      setWoNumber(order.number);
      setDescription(order.description);
      setAsset(order.asset);
      setCustomerPONumber(order.customerPONumber);
      setCustomer(order.customer);
      setCustomerName(order.customer?.companyName ?? null);
      setNte(order.NTE);
      setServiceType(order.serviceType);
      setQuotedByUser(order.quotedBy);
      setStatus(order.status);
      if (order.startDate) setStartDate(order.startDateString);
    } else {
      setWoNumber("");
      setDescription("");
      setAsset("");
      setCustomerPONumber("");
      setCustomer(null);
      setCustomerName(null);
      setNte(0);
      setServiceType(null);
      setStatus(0);
      setStartDate(moment().format("MM/DD/YYYY"));
      setPrimaryTech(null);
      setQuotedByUser(null);
    }
  }, [shown]);

  useEffect(() => {
    getTechnicians();
  }, [branch]);

  const getCustomers = async () => {
    try {
      const response = await CustomerService.getForAssign(customerKeyword);
      setCustomers(response.data);
      setCustomerNames(response.data.map((item) => item.companyName));
    } catch (error) {
      console.log("customer fetching error: ", error);
    }
  };

  const getTechnicians = async () => {
    // Roles are dynamic (managed in IAM), so the picker lists all enabled
    // users instead of hardcoding role names.
    UserService.getUsersForAssign(null, branch)
      .then((response) => {
        if (response.status == 200) {
          setTechnicians(
            response.data.filter((user) => user.isEnabled === true).sort((a, b) => a.name.localeCompare(b.name)),
          );
        }
      })
      .catch((error) => handleError(error));
  };

  const primaryTechSelected = (i) => {
    if (i == -1) {
      setIsUserDropDownOpen(false);
    } else if (i == -2) {
      setIsUserDropDownOpen(true);
    } else {
      setPrimaryTech(technicians[i]);
      setIsUserDropDownOpen(false);
    }
  };

  const customerSelected = (index) => {
    console.log("customers[index]: ", customers[index]);
    setCustomer(customers[index]);
    setCustomerName(customers[index].companyName);
  };

  const quotedByUserSelected = (index) => {
    if (index === null || index === undefined || index < 0 || index >= quotedByUsers.length) {
      setQuotedByUser(null);
      return;
    }
    setQuotedByUser(quotedByUsers[index]);
  };

  // WO numbers are auto-assigned (and locked) by the backend on create, so a
  // WO number is only required when editing an existing order.
  const isSubmitDisabled =
    isSubmitting || !customer || serviceType === null || (order && (!woNumber || woNumber.trim().length === 0));

  const submitClicked = async () => {
    if (isSubmitDisabled) return;

    let data = {};
    if (order) {
      // WO number is locked and never editable, so it is never part of the update.
      if (order.customer.id !== customer.id) data["customer"] = customer;
      if (order.asset !== asset) data["asset"] = asset;
      if (order.customerPONumber !== customerPONumber) data["customerPONumber"] = customerPONumber;
      if (order.serviceType?.id !== serviceType?.id) data["serviceType"] = serviceType;
      if (order.quotedBy?.id !== quotedByUser?.id) data["quotedBy"] = quotedByUser;
      if (order.NTE !== nte) data["NTE"] = nte;
      if (order.description !== description) data["description"] = description;
      if (order.status !== status) data["status"] = status;
      if (!moment(order.startDateString).isSame(moment(startDate), "day"))
        data["startDate"] = formatDate(startDate, "YYYY-MM-DD");
    } else {
      let branchId = branch;
      // if (isProjectManagerOver() || isAccountant()) {
      //   branchId = branch;
      // } else {
      //   branchId = currentUser.branches[0].id;
      // }

      data = {
        openDate: new Date(),
        openUser: currentUser,
        // WO number is auto-assigned and locked by the backend from the branch prefix.
        customer: customer,
        // asset: asset,
        // customerPONumber: customerPONumber,
        status: 1, //requested
        // serviceType: serviceType,
        // NTE: nte,
        // description: description,
        startDate: formatDate(startDate, "YYYY-MM-DD"),
        branch: branchId,
        company: currentUser.company,
      };

      if (asset.length > 0) {
        data.asset = asset;
      }
      if (customerPONumber.length > 0) {
        data.customerPONumber = customerPONumber;
      }
      if (serviceType !== null) {
        data.serviceType = serviceType;
      }
      if (nte) {
        data.NTE = nte;
      }
      if (description.length > 0) {
        data.description = description;
      }
      if (quotedByUser) {
        data.quotedBy = quotedByUser;
      }
    }

    console.log("new wo data: ", data);

    // Keep the button disabled until the parent's save request settles, then
    // release it so a failed request can be retried from the same modal.
    setIsSubmitting(true);
    try {
      await onSubmitClicked(data, primaryTech);
    } finally {
      setIsSubmitting(false);
    }
  };

  const addServiceType = (newServiceType) => {
    setShowAddServiceTypeModal(false);
    const payload = {
      serviceType: newServiceType,
      company: currentUser.company,
    };
    ServiceTypeService.save(payload).then((response) => {
      if (response.status == 201 && response.data) {
        setServiceType(response.data);
      }
    });
  };

  return (
    shown && (
      <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30">
        {datePickerOpen && (
          <DatePickerModal
            shown={datePickerOpen}
            pSelectedDate={startDate}
            cancelClicked={() => setDatePickerOpen(false)}
            dateSelected={(date) => {
              setStartDate(date);
              setDatePickerOpen(false);
            }}
          />
        )}
        {showAddServiceTypeModal && (
          <ServiceTypeAddModal
            serviceType={null}
            onCancel={() => setShowAddServiceTypeModal(false)}
            onSave={addServiceType}
          />
        )}

        <OutsideClickHandler onOutsideClick={() => !showAddServiceTypeModal && !isSubmitting && onCancelClicked()}>
          <div className="w-[436px] bg-white rounded-[6px] p-[18px] flex flex-col relative">
            {order && (
              <div className="absolute top-2 right-2 flex items-center gap-2">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor">Status: </p>
                <div className="w-[120px] ">
                  <WOStatusDropDown defaultOption={status} onSelect={(value) => setStatus(value)} />
                </div>
              </div>
            )}
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor mb-5">
              {order ? vocabularize("EDIT WORK ORDER") : vocabularize("CREATE WORK ORDER")}
            </p>
            <div className=" w-full">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">{vocabularize("Work Order")} #</p>
              <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center px-[15px] bg-gray-100">
                <span className="w-full text-[11px] font-[400] font-OpenSansMedium text-gray-500">
                  {order ? woNumber : "Auto-assigned from branch prefix"}
                </span>
              </div>
              <p className="text-gray-400 text-[10px] font-OpenSansMedium mt-1">
                {vocabularize("Work Order numbers are assigned automatically and cannot be changed.")}
              </p>
            </div>

            <div className="flex flex-col justify-between h-full mt-4">
              <div className="h-[60px] w-full mb-2">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">
                  Customer <span className="text-red-500">*</span>
                </p>
                <CustomerDropDown
                  options={customerNames}
                  defaultOption={customerName}
                  onSelect={customerSelected}
                  keywordChanged={setCustomerKeyword}
                />
              </div>

              <div className="h-[60px] w-full mb-2">
                <div className="flex items-center justify-between">
                  <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">
                    Type of Service <span className="text-red-500">*</span>
                  </p>
                  {can("service:create") && (
                    <p
                      onClick={() => setShowAddServiceTypeModal(true)}
                      className="text-[12px] font-[600] font-OpenSansRegular text-subTitleColor cursor-pointer"
                    >
                      + Add Service Type
                    </p>
                  )}
                </div>
                <ServiceTypeDropdown selectedItem={serviceType} onSelect={setServiceType} />
              </div>

              {serviceType?.serviceType === "Quoted Job" && (
                <div className="h-[60px] w-full mb-2">
                  <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">Quoted By</p>
                  <QuotedByDropdown
                    options={quotedByUsers}
                    defaultOption={quotedByUser}
                    onSelect={quotedByUserSelected}
                  />
                </div>
              )}

              <div className="h-[60px] w-full mb-2">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">NTE</p>
                <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
                  <span className="text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium mr-[1px]">$</span>
                  <input
                    value={nte}
                    type="number"
                    onChange={(e) => setNte(e.target.value)}
                    className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                    placeholder="Enter NTE"
                  />
                </div>
              </div>

              <div className="h-[60px] w-full mb-2">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Start Date</p>

                <DatePicker
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(date);
                  }}
                  customInput={<StartInput />}
                />
              </div>

              <div className="w-full mb-2">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">{vocabularize("Asset")}</p>
                <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
                  <input
                    value={asset}
                    type="text"
                    onChange={(e) => setAsset(e.target.value)}
                    className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                    placeholder={vocabularize("Enter Asset")}
                  />
                </div>
              </div>

              <div className="w-full mb-2">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">
                  Customer Purchase Order #
                </p>
                <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
                  <input
                    value={customerPONumber}
                    type="text"
                    onChange={(e) => setCustomerPONumber(e.target.value)}
                    className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                    placeholder="Enter Customer Purchase Order Number"
                  />
                </div>
              </div>

              {!order && (
                <div className="w-full mb-2">
                  <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">
                    Assign Primary Technician
                  </p>
                  <UserDropDown
                    options={technicians}
                    selectedUser={primaryTech}
                    onSelect={primaryTechSelected}
                    isOpen={isUserDropDownOpen}
                  />
                </div>
              )}

              <div className="w-full mb-2">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">Description</p>
                <textarea
                  value={description}
                  type="text"
                  onChange={(e) => setDescription(e.target.value)}
                  multiple={true}
                  className="w-full h-[70px] order-solid border-[1px] rounded-[5px] text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium px-2 py-1"
                  placeholder="Enter Description"
                />
              </div>

              <div className="w-full mt-2">
                <div className="flex items-center justify-between gap-4">
                  <div
                    onClick={onCancelClicked}
                    className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                  >
                    CANCEL
                  </div>
                  <button
                    type="button"
                    onClick={submitClicked}
                    disabled={isSubmitDisabled}
                    className={`w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center ${
                      isSubmitDisabled
                        ? "bg-gray-300 text-white cursor-not-allowed"
                        : "bg-blueColor text-white cursor-pointer"
                    }`}
                  >
                    {isSubmitting ? <Loader variant="inline" size={16} ariaLabel="submitting-work-order" /> : "SUBMIT"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    )
  );
}

export default CreateWoModal;
